// pages/Login/LoginCredentials.tsx
import React from 'react';
import { Card, HeaderText, BodyText, Container, Row, Col } from 'shared-portal-component';

import LoginForm from '@/components/organism/Login/LoginForm';
import { useAuthCredentials } from '@/hooks/auth/useAuthCredentials';

/**
 * /login route
 * Handles credential submission
 */
const LoginCredentials: React.FC = () => {
  const { state, handlers } = useAuthCredentials();
  return (
     <Container fluid>
        <Card>
          <Row spacing="md">
            <Col size={12}>
              <HeaderText text="Welcome!" size="h2" className="header-text-auth" />
              <BodyText text="Please login to your user account." className="body-text-auth" as="p" />
            </Col>
          </Row>
          <LoginForm
            onSubmit={(values) => { void handlers.submit(values); }}
            loading={state.isLoading}
            error={state.error}
            fieldErrors={state.fieldErrors}
          />
        </Card>
      </Container>
  );
};

export default LoginCredentials;
